export default __webpack_public_path__ + "static/Dollarsmart_logo-3e199285ff9018b33a8187e4d6050ecf.png";